import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-activation-link-expired',
    templateUrl: './activation-link-expired.component.html',
    styleUrls: ['./activation-link-expired.component.scss'],
    standalone: false
})
export class ActivationLinkExpiredComponent {
  @Output() resendVerificationLink: EventEmitter<void> = new EventEmitter<void>();

  onResendVerificationLink() {
    this.resendVerificationLink.emit();
  }
}
